import type { DriverTopUpInput } from '@chukua/common';
import { useState } from 'react';
import { useToast } from '../../../shared/hooks/use-toast';
import { apiErrorMessage } from '../../../shared/policies/api-error-message';
import { ApiError } from '../../../shared/shared.api';
import { topUpTrip } from '../dispatch.api';

/** Giving a driver more cash on a trip already out. `onGiven` lets the page reload what the trip shows. */
export function useTripTopUp(tripId: string, onGiven: () => void) {
  const toast = useToast();
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [error, setError] = useState<string | null>(null);

  async function giveTopUp(input: DriverTopUpInput): Promise<boolean> {
    setIsSubmitting(true);
    setError(null);
    try {
      await topUpTrip(tripId, input);
      toast.success('Top-up recorded');
      onGiven();
      return true;
    } catch (err) {
      setError((err instanceof ApiError ? apiErrorMessage(err) : undefined) ?? 'Could not record the top-up. Try again.');
      return false;
    } finally {
      setIsSubmitting(false);
    }
  }

  return { giveTopUp, isSubmitting, error, clearError: () => setError(null) };
}
